<template>
  <div class="alipay">
    <h4>
      以下城市可直接在支付宝上申请代开发票：
    </h4>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMja2l-9tmmAcySUAADbY5ayRU0081.png" alt="" width="100%" />
    </div>
    <div style="color: red">支付宝上代开发票注意事项：</div>
    <div>
      一、单笔开票含税金额需在515元-51500元之间，否则无法在支付宝上开具；
    </div>
    <div>二、电子票一单开具，无法红冲作废，税金也无法退回。</div>
    <h4>
      <center>杭州娃哈哈电子商务有限公司开票信息：</center>
    </h4>
    <div>
      名称：杭州娃哈哈电子商务有限公司 开户行及账号：工商银行杭州解放路支行 1202020709920528811
    </div>
    <div>纳税人识别号：91330109MA2H31195K</div>
    <div>
      地址、电话：浙江省杭州市萧山区经济技术开发区启迪路198号A-B102-1339室
      <a href="tel:0571-81067351">0571-81067351</a>
    </div>
    <div>开户行及账号：工商银行杭州解放路支行 1202020709920528811</div>
    <h4></h4>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMjadV-9tvaAVdjnAADdnui2KOc973.jpg" width="100%" alt="" />
    </div>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMja2l-9t12AF-4lAAEvA6gRFUA466.jpg" width="100%" alt="" />
    </div>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMjadV-9t4iAKMGsAACqPW2YkWs463.jpg" width="100%" alt="" />
    </div>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMja2l-9t7KATokTAAC0Iku4qPA893.jpg" width="100%" alt="" />
    </div>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMjadV-9t9uAUNFIAAGAHEw_qMg339.jpg" width="100%" alt="" />
    </div>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMja2l-9uBGAIJBPAADSwOtvenE559.jpg" width="100%" alt="" />
    </div>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMjadV-9uEeAQgqvAADfBF2ZClI213.jpg" width="100%" alt="" />
    </div>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMja2l-9uHWAF624AADfS_g75ME535.jpg" width="100%" alt="" />
    </div>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMjadV-9uJeAerapAAEa7wc2wnw439.jpg" width="100%" alt="" />
    </div>
    <div>
      <img src="https://file.whhhealth.com/group1/M00/03/09/wMjadV-9uLyAQuLYAAE8lJDNPM4247.jpg" width="100%" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BillAlipay',
  data() {
    return {};
  },
  computed: {},
  metaInfo() {
    return { title: '支付宝个人代开发票操作手册' };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.alipay {
  padding: 18px 12px;
}
</style>
